import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import ReviewCardsTask from './ReviewCardsTask';
import ReviewItemSwapsTask from './ReviewItemSwapsTask';
import ReviewComplianceSwapsTask from './ReviewComplianceSwapsTask';
import ReviewPacksTask from './ReviewPacksTask';
import LogOnEnter from '../../CustomComponents/LogOnEnter';

function TaskList(props) {
    const shouldShowItemSwaps = () => {
        // return props.headlineData?.tasks?.total_swaps > 0;
        // Hard coding to false for now since we have swaps across campaigns that are accessible from the all campaign landing page rather than from within campaigns
        return false;
    }

    const shouldShowComplianceSwaps = () => {
        // return props.headlineData?.tasks?.total_compliance_swaps > 0;
        // Also hard coding this to false for now since it is not used and can intefere with testing/demo of swaps due to seeded data
        return false;
    }

    const shouldShowPacks = () => {
        return props.headlineData?.tasks?.pack_review_summary?.packs_total_count > 0;
    }

    const shouldShowCardsTask = () => {
        return props.headlineData?.tasks?.active_drafts > 0;
    }

    const hasOptimizations = useMemo(() => {
        return props.headlineData.optimizations_enabled;
    }, [props.headlineData.optimizations_enabled]);

    return (
        <LogOnEnter action='viewed_task_list' data={{}}>
            <Stack pt={hasOptimizations ? 2 : 0}>
                <Typography variant='heavy' sx={{ 'fontSize': '16px' }}>Things To Do</Typography>
                <Stack pt={2} spacing={4}>
                    { shouldShowItemSwaps() && 
                        <ReviewItemSwapsTask 
                            cardOwner={props.cardOwner} 
                            totalRecs={props.headlineData?.tasks?.total_swaps}
                            activeRecs={props.headlineData?.tasks?.active_swaps}
                            campaign={props.campaign}
                        />
                    }
                    { shouldShowComplianceSwaps() &&
                        <ReviewComplianceSwapsTask 
                            cardOwner={props.cardOwner} 
                            totalRecs={props.headlineData?.tasks?.total_compliance_swaps} 
                            activeRecs={props.headlineData?.tasks?.active_compliance_swaps} 
                            complianceDebt={props.headlineData?.compliance_debt}
                            campaign={props.campaign}
                        />
                    }
                    { shouldShowPacks() && 
                        <ReviewPacksTask 
                            cardOwner={props.cardOwner} 
                            totalPacks={props.headlineData?.tasks?.pack_review_summary?.packs_total_count}
                            submittedPacks={props.headlineData?.tasks?.pack_review_summary?.packs_submitted_count}
                        />
                    }
                    { shouldShowCardsTask() && 
                        <ReviewCardsTask 
                            cardOwner={props.cardOwner} 
                            drafts={props.drafts} 
                            campaignHasOptimizations={hasOptimizations}
                        />
                    }
                </Stack>
            </Stack>
        </LogOnEnter>
    );
}

export default TaskList;